<div *ngIf="addressVisibility == 'billing' || addressVisibility == 'both' " class="container-address is-relative">
    <p class="subtitle has-text-weight-semibold">Rechnungsanschrift</p>
    <p>{{ (selectedBillingAddress$ | async)?.gesoftName1 }}</p>
    <p>{{ (selectedBillingAddress$ | async)?.gesoftName2 }}</p>
    <p>{{ (selectedBillingAddress$ | async)?.street }}</p>
    <p>{{ (selectedBillingAddress$ | async)?.postcode }} {{ (selectedBillingAddress$ | async)?.town }}</p>
    <p *ngIf="(selectedBillingAddress$ | async)?.elevator || (selectedBillingAddress$ | async)?.floor !== undefined">
        <span *ngIf="(selectedBillingAddress$ | async)?.floor">Etage: {{ (selectedBillingAddress$ | async)?.floor }}</span>
        <span *ngIf="(selectedBillingAddress$ | async)?.floor !== undefined">
                                Aufzug: <span *ngIf="(selectedBillingAddress$ | async)?.elevator">Ja</span><span
                *ngIf="!(selectedBillingAddress$ | async)?.elevator">Nein</span>
                            </span>
    </p>
    <div class="container-button">
        <button *ngIf="visibilityNewButton && countAddresses() > 1" class="button mt-2 mr-2"
                (click)="setEditAddress('billing', true)">Neue Adresse
        </button>
        <button (click)="setEditAddress('billing')" class="button mt-2">Anschrift ändern</button>
    </div>
</div>
<div *ngIf="addressVisibility == 'delivery' || addressVisibility == 'both' "
     [ngClass]="addressVisibility == 'both' ? 'mt-5' : ''" class="container-address is-relative">
    <p class="subtitle has-text-weight-semibold">Lieferanschrift</p>
    <div
            *ngIf="((selectedBillingAddress$ | async)?.addressId !== (selectedDeliveryAddress$ | async)?.addressId) && (selectedDeliveryAddress$ | async)?.addressId  ">
        <p>{{ (selectedDeliveryAddress$ | async)?.gesoftName1 }}</p>
        <p>{{ (selectedDeliveryAddress$ | async)?.gesoftName2 }}</p>
        <p>{{ (selectedDeliveryAddress$ | async)?.street }}</p>
        <p>{{ (selectedDeliveryAddress$ | async)?.postcode }} {{ (selectedDeliveryAddress$ | async)?.town }}</p>
        <p *ngIf="(selectedDeliveryAddress$ | async)?.elevator || (selectedDeliveryAddress$ | async)?.floor !== undefined">
            <span *ngIf="(selectedDeliveryAddress$ | async)?.floor">Etage: {{ (selectedDeliveryAddress$ | async)?.floor }}</span>
            <span *ngIf="(selectedDeliveryAddress$ | async)?.floor !== undefined">
                                Aufzug: <span *ngIf="(selectedDeliveryAddress$ | async)?.elevator">Ja</span><span
                    *ngIf="!(selectedDeliveryAddress$ | async)?.elevator">Nein</span>
                            </span>
        </p>
    </div>
    <p
            *ngIf="((selectedBillingAddress$ | async)?.addressId == (selectedDeliveryAddress$ | async)?.addressId) ||  !(selectedDeliveryAddress$ | async)?.addressId ">
        Entspricht der Rechnungsanschrift</p>
    <div class="container-button">
        <button *ngIf="visibilityNewButton" class="button mt-2 mr-2"
                (click)="setEditAddress('delivery', true)">Neue Adresse
        </button>
        <button class="button mt-2" (click)="setEditAddress('delivery')">Lieferanschrift ändern</button>
    </div>

</div>

<div *ngIf="editAddress" class="modal" [ngClass]="editAddress ? 'is-active' : ''">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title"><span *ngIf="editAddress.addressType == 'billing'">Rechnungsadresse</span><span
                    *ngIf="editAddress.addressType == 'delivery'">Lieferadresse</span><span
                    *ngIf="!editAddress.addressType">Adresse</span></p>
            <button class="delete" (click)="editAddress = undefined"></button>
        </header>
        <section class="modal-card-body">
            <iw-shop-customer-addresses (onSelectAddress)="editAddress = undefined"
                                        (onUpdateAddressSuccess)="editAddress = undefined"
                                        [activeTab]="editAddress.activeTab "
                                        [selectedAddressId]="editAddress.addressId" [isSelectAddress]="true"
                                        [isAddressOverview]="false"
                                        [addressType]="editAddress.addressType"></iw-shop-customer-addresses>
        </section>
    </div>
</div>
